import * as Yup from 'yup';
import { RepresentativeSchema } from './representative';

const qohMinPercents = [25, 30, 50, 75, 100, 125, 150, 175, 200] as const;
type QOHMinPercent = (typeof qohMinPercents)[number];

const salesPeriodDays = [7, 14, 30, 60, 90, 180, 365] as const;
export type SalesPeriodDays = (typeof salesPeriodDays)[number];

export const thresholdWeeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type ThresholdWeeks = (typeof thresholdWeeks)[number];

export const reorderWeeks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type ReorderWeeks = (typeof reorderWeeks)[number];

// form validation rules
const OrderDefaultsSchema = Yup.object().shape({
  qoh_threshold_weeks: Yup.mixed<ThresholdWeeks>().oneOf(thresholdWeeks).defined().required(),
  reorder_weeks: Yup.mixed<ReorderWeeks>().oneOf(reorderWeeks).defined().required(),

  send_method: Yup.string().defined(),

  // Deprecated
  qoh_threshold_percent: Yup.mixed<QOHMinPercent>().oneOf(qohMinPercents).defined().required(),
  sales_period_days: Yup.mixed<SalesPeriodDays>().oneOf(salesPeriodDays).defined().required(),
});

export const OrderSettingsSchema = Yup.object().shape({
  defaults: OrderDefaultsSchema.required(),

  send_methods: Yup.array().of(Yup.string().required()).required(),
  representatives: Yup.array().of(RepresentativeSchema.required()).required(),
});

export type OrderSettings = Yup.InferType<typeof OrderSettingsSchema>;
